import { render, staticRenderFns } from "./InfoClinic.vue?vue&type=template&id=5ca55beb"
import script from "./InfoClinic.vue?vue&type=script&lang=js"
export * from "./InfoClinic.vue?vue&type=script&lang=js"
import style0 from "./InfoClinic.vue?vue&type=style&index=0&id=5ca55beb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports